// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as StoreFx__Play from "./play.jsx";
import * as StoreFx__UpdatePlayQueue from "./updatePlayQueue.jsx";

function make(current, queued, param) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    store.setState(function (prevState) {
      const init = prevState.player;
      return {
        albums: prevState.albums,
        artists: prevState.artists,
        auth: prevState.auth,
        player: {
          buffered: init.buffered,
          currentSongId: current,
          currentTime: init.currentTime,
          duration: init.duration,
          muted: init.muted,
          paused: init.paused,
          queuedSongIds: init.queuedSongIds,
          replayGainOptions: init.replayGainOptions,
          volume: init.volume
        },
        songs: prevState.songs
      };
    });
    return Fx.Monad_syntax.let$star(StoreFx__Play.make(undefined), (function (param) {
      return Fx.$$catch(StoreFx__UpdatePlayQueue.make(function (prevState) {
        const state = store.getState();
        const arg = state.player.queuedSongIds;
        return {
          current: prevState.current,
          currentTime: prevState.currentTime,
          queued: (function (param) {
            return Stdlib__Option.value(param, arg);
          })(queued)
        };
      }), (function (param) {
        return {
          TAG: /* Error */ 1,
          _0: undefined
        };
      }));
    }));
  }));
}

export {
  make,
}
/* StoreFx__Play Not a pure module */
